import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';
import { FormattedMessage } from 'react-intl';

import Button from '../../../components/Button';
import Select from '../../../components/Select';
import messages from '../../../locale/messages';
import style from '../ScheduleForm/ScheduleForm.scss';
import {customisedIntlFormatMessage} from '../../../utils/helpers';

const ANIMATION_DURATION = 700;

export const ExpressedInterestSelectInstrumentsStep = ({
  schoolNameButtonClasses,
  stepButtonClasses,
  program,
  intl,
  title,
  show,
  nextClicked,
  selectionChanged,
  selectedOptionOne,
  selectedOptionTwo,
  instrumentsOptions,
  firstInstrumentName,
  secondInstrumentName,
  error,
  errorMessage,
  titleAccommodation,
  isLaGuardia
}) => {
  let bodyCopy = `Select the instrument you'd like to audition for. You can choose as many as two.`;
  if(isLaGuardia){
    bodyCopy = customisedIntlFormatMessage(intl, messages.generalStringMandatoryInstrumentLaGuardia);
  }
  const { id: otherId } = instrumentsOptions ? instrumentsOptions.find(({ name }) => name === 'Other') : null;
  let schoolName = '';
  if(program.school && program.school.name)
    schoolName = program.school.name;
  else
    schoolName = program.directory_school_name;
  return (
    <div className={style.scheduleFormStepContainer}>
      <div className={style.scheduleFormStepContainer}>
        <div className={style.scheduleFormStepTitleContainer}>
          <button disabled aria-label={schoolName} className={classNames(...schoolNameButtonClasses)}>
            <div className={style.scheduleFormStepButtonIcon}>
              <i className="icon-Check" />
            </div>
            <div className={style.scheduleFormStepTitle}>
              <div>{schoolName}</div>
              <div>
                <i className="icon-Star" /> {program.name}
              </div>
            </div>
          </button>
        </div>
      </div>
      {!isLaGuardia && (<div className={style.scheduleFormStepContainer}>
        <div className={style.scheduleFormStepTitleContainer}>
          <button disabled aria-label={schoolName} className={classNames(...schoolNameButtonClasses)}>
            <div className={style.scheduleFormStepButtonIcon}>
              <i className="icon-Check" />
            </div>
            <div className={style.scheduleFormStepTitle}>
              <div>
                {titleAccommodation}
              </div>
              <div>{/* <i className="icon-Star" /> {program.name} */}</div>
            </div>
          </button>
        </div>
      </div>)}
      <div className={style.scheduleFormStepContainer}>
        <div className={style.scheduleFormStepTitleContainer}>
          <button disabled className={classNames(...stepButtonClasses)}>
            <span className={style.scheduleFormStepButtonIcon}>
              <i className="icon-Pencil" />
            </span>
            <h2 className={style.scheduleFormStepTitleActive}>{title}</h2>
          </button>
        </div>
        <AnimateHeight duration={ANIMATION_DURATION} height={show ? 'auto' : 0} animateOpacity>
          <div className={style.scheduleFormStepWrapper}>
            <div className={style.scheduleFormStep}>
              <div>{bodyCopy}</div>
              <br />
              <div>
                <div
                  className={classNames(
                    style.scheduleFormCheckboxes,
                    style.scheduleFormCheckboxesIndented,
                  )}
                >
                  <div className={style.scheduleFormInputWrapper}>
                  {isLaGuardia && <b><i>{customisedIntlFormatMessage(intl, messages.generalStringPrimaryInstrumentLaGuardia)}</i></b>}
                  <Select
                    options={instrumentsOptions}
                    selectKey={firstInstrumentName}
                    onSelectionChange={selectionChanged}
                    selected={selectedOptionOne.description}
                  />
                  </div>
                  {selectedOptionOne.instrument_id === otherId && (
                    <input
                      onChange={event => selectionChanged(firstInstrumentName, otherId, event.target.value)}
                      className={style.scheduleFormInput}
                    />
                  )}
                  
                  <div className={style.scheduleFormInputWrapper}>
                  {isLaGuardia && <i> {customisedIntlFormatMessage(intl, messages.generalStringSecondaryInstrumentLaGuardia)}</i>}
                  {!isLaGuardia && <i>Optional:</i>}
                    <Select
                      options={instrumentsOptions}
                      selectKey={secondInstrumentName}
                      onSelectionChange={selectionChanged}
                      selected={selectedOptionTwo ? selectedOptionTwo.description : customisedIntlFormatMessage(intl, messages.selectInstrumentOption)}
                    />
                  </div>
                  {selectedOptionTwo && selectedOptionTwo.instrument_id === otherId && (
                    <input
                      onChange={event => selectionChanged(secondInstrumentName, otherId, event.target.value)}
                      className={style.scheduleFormInput}
                    />
                  )}
                </div>
                {error && (
                  <div className={style.scheduleFormError}>
                    <FormattedMessage {...errorMessage} />
                  </div>
                )}
                {selectedOptionOne.description !== customisedIntlFormatMessage(intl, messages.selectInstrumentOption) && (
                  <div className={style.scheduleFormProgressButtonWrapper}>
                    <Button label={customisedIntlFormatMessage(intl, messages.generalStringNext)} onClick={nextClicked} />
                  </div>
                )}
                {isLaGuardia && selectedOptionOne.description == customisedIntlFormatMessage(intl, messages.selectInstrumentOption) && (
                  <div className={style.scheduleFormProgressButtonWrapper}>
                    <Button label={customisedIntlFormatMessage(intl, messages.generalStringNext)} disabled/>
                  </div>
                )}
              </div>
            </div>
          </div>
        </AnimateHeight>
      </div>
      <div className={style.scheduleFormStepContainer}>
        <div className={style.scheduleFormStepTitleContainer}>
          <button disabled aria-label={program.schoolName} className={classNames(...schoolNameButtonClasses)}>
            <div className={style.scheduleFormStepButtonIcon}>
              <i className="icon-Check" />
            </div>
            {isLaGuardia && (<div className={style.scheduleFormStepTitle}>{customisedIntlFormatMessage(intl, messages.generalStringSaveInstrumentsLaGuardia)}</div>)}
            {!isLaGuardia && (<div className={style.scheduleFormStepTitle}>Register</div>)}
          </button>
        </div>
      </div>
    </div>
  );
};

ExpressedInterestSelectInstrumentsStep.propTypes = {
  schoolNameButtonClasses: PropTypes.arrayOf(PropTypes.string).isRequired,
  stepButtonClasses: PropTypes.arrayOf(PropTypes.string).isRequired,
  program: PropTypes.shape({
    name: PropTypes.string,
    school: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
  intl: PropTypes.object.isRequired,
  // intl: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  nextClicked: PropTypes.func.isRequired,
  selectionChanged: PropTypes.func.isRequired,
  // selectedOption: PropTypes.shape({
  //   firstInstrument: PropTypes.string,
  //   secondInstrument: PropTypes.string,
  // }).isRequired,
  selectedOptionOne: PropTypes.shape({
    instrument_id: PropTypes.number,
    description: PropTypes.string,
  }).isRequired,
  selectedOptionTwo: PropTypes.shape({
    instrument_id: PropTypes.number,
    description: PropTypes.string,
  }),
  instrumentsOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  firstInstrumentName: PropTypes.string.isRequired,
  secondInstrumentName: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  // errorMessage: PropTypes.string.isRequired,
  errorMessage: PropTypes.object.isRequired,
  isLaGuardia: PropTypes.bool
};

export default ExpressedInterestSelectInstrumentsStep;
